/* eslint-disable sort-keys */
import * as core from '../../../../../../../core'

import { query } from './overview.query'

export const RESOURCE = {
  payload: {
    alias: 'overview',
    content: {
      navigator: core.mosaic.Page.Segment.Navigator.Tabs,
      segments: [
        {
          name: 'Overview',
          root: {
            elements: [
              {
                height: 800,
                content: {
                  widget: {
                    widget: {
                      alias: 'health-check-table',
                    },
                  },
                },
              },
            ],
          },
          alias: 'overview',
          query: {},
        },
      ],
    },
    description: 'Overview of health checks at different levels.',
    name: 'Overview',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicPage>
